"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.volatileOrganicCompound = void 0;
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const tsdb_1 = require("../tsdb");
const VariableName_1 = require("../VariableName");
exports.volatileOrganicCompound = {
    __basic_data_type: true,
    __slotted_variable_name_data_type: true,
    __tsdb_data_type: true,
    __variable_name_data_type: true,
    id: 'volatileOrganicCompound',
    variableName: VariableName_1.VariableName.volatileOrganicCompound,
    dbTable: tsdb_1.TSDBTable.volatileOrganicCompound,
    title: 'VOC',
    icon: free_solid_svg_icons_1.faWind,
    isSlotted: true,
    order: 5,
    graphQLSampleKey: 'vOC',
    bucketing: {
        min: 200,
        max: 1200,
        numberOfBuckets: 10,
    },
    decimals: 1,
    colormap: [
        { value: 300, rgb: [0, 255, 0, 1] },
        { value: 580, rgb: [0, 255, 0, 1] },
        { value: 1000, rgb: [255, 0, 0, 1] },
    ],
    dataPointConverter: x => x,
    unit: 'ppb',
};
//# sourceMappingURL=volatile-organic-compound.js.map